import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    realisasiPPA: Yup.object().shape({
      tglRealisasiPPA: Yup.string().required("Masukan tgl ppa").nullable(),
    }),
  });
